import { useFormik } from "formik";
import { ModalComponent } from "..";
import { useChangePasswordMutation } from "../../../redux/features/auth/auth.api";
import { changePasswordSchema } from "../../../validationSchema";
import { TextInput } from "../../inputs/textInput";

export const ChangePasswordModal = ({
  isModalOpen,
  onModalClose,
  successCallback = () => {},
}: {
  isModalOpen: boolean;
  onModalClose: () => void;
  successCallback?: () => void;
}) => {
  const [changePassword, { isLoading }] = useChangePasswordMutation();

  const {
    values,
    errors,
    isValid,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    resetForm,
  } = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    },
    validationSchema: changePasswordSchema,
    onSubmit: async (data) => {
      const resp = await changePassword({
        oldpassword: data?.oldPassword,
        password: data?.newPassword,
      });

      if (resp.data?.success) {
        resetForm();
        onModalClose();
        successCallback();
      }
    },
  });
  return (
    <ModalComponent
      isModalOpen={isModalOpen}
      onModalClose={() => {
        resetForm();
        onModalClose();
      }}
      title="Change Password"
      subTitle="Kindly ensure you keep your password safe."
      childrenClassName=""
      modalClassName=""
      hasButtons
      proceedButtonText="Change Password"
      onProceedClick={handleSubmit}
      hasCancelButton={false}
      isLoading={isLoading}
      isProceedDisabled={isLoading || !isValid}
    >
      <div className="flex flex-col gap-3">
        <TextInput
          type="password"
          name="oldPassword"
          value={values?.oldPassword}
          placeholder="Enter current password"
          onChange={handleChange}
          onBlur={handleBlur}
          hasIcon={false}
          iconSvg={undefined}
          errors={
            errors?.oldPassword && touched?.oldPassword
              ? errors?.oldPassword
              : ""
          }
          autoComplete="off"
        />
        <TextInput
          type="password"
          name="newPassword"
          value={values?.newPassword}
          placeholder="Enter new password"
          onChange={handleChange}
          onBlur={handleBlur}
          hasIcon={false}
          iconSvg={undefined}
          errors={
            errors?.newPassword && touched?.newPassword
              ? errors?.newPassword
              : ""
          }
          autoComplete="off"
        />
        <TextInput
          type="password"
          name="confirmNewPassword"
          value={values?.confirmNewPassword}
          placeholder="Enter new password again"
          onChange={handleChange}
          onBlur={handleBlur}
          hasIcon={false}
          iconSvg={undefined}
          errors={
            errors?.confirmNewPassword && touched?.confirmNewPassword
              ? errors?.confirmNewPassword
              : ""
          }
          autoComplete="off"
        />
      </div>
    </ModalComponent>
  );
};
